import RequestToken from '../../../../tokens/RequestToken';
import {CommandRequester} from '../../../../CommandRequester';
import RequestAPI from '../../../RequestAPI';
import {AsyncCommandEvent, CommandTypes} from '@jibo/command-protocol';

/**
 * @class SayToken
 * @extends RequestToken
 * @hideconstructor
 */
export class SayToken extends RequestToken<JIBO.v1.SayRequest> {

    /** @private */
    constructor(owner:CommandRequester, protocol: JIBO.v1.SayRequest) {
        super(owner, protocol);
    }

    /**
     * @private
     */
    public handleAck(ack:JIBO.v1.Acknowledgement) {
        //handle ack
        if (ack.Response.ResponseCode >= 400) {
            this.isComplete = true;
            this._complete.reject(ack.Response);
            return;
        }
    }

    /**
     * @private
     */
    public handleEvent(event:JIBO.v1.EventMessage) {
        //handle event
        switch (event.EventBody.Event) {
            case AsyncCommandEvent.Stop:
                this.isComplete = true;
                this._complete.resolve();
                break;
            case AsyncCommandEvent.Error:
                this.isComplete = true;
                this._complete.reject(event.EventBody);
                break;
        }
    }
}

/**
 * Internal Say class
 * @class CommandRequester.expression.Say
 * @intdocs
 */
export class Say extends RequestAPI<JIBO.v1.SayRequest, SayToken> {

    /**
     * Generate Say Protocol
     * @method CommandRequester.expression.Say#generateProtocol
     * @param {string} esml_uri - ESML to speak or URI of sound to say
     * @param {JIBO.v1.SpeakOptions} [speakOptions] Options to configure , can be used in conjunction with ESML strings.
     * @param {JIBO.v1.AutoRuleConfig} [autoRuleConfig] Configuration for AutoRules , can be used in conjunction with ESML strings.
     * @returns {SayRequest}
     * @intdocs
     */
    static generateProtocol(esmlUri: string, speakOptions?:JIBO.v1.SpeakOptions, autoRuleConfig?:JIBO.v1.AutoRuleConfig ): JIBO.v1.SayRequest {
        return {
            Type: CommandTypes.Say,
            ESML: esmlUri,
            SpeakOptions: speakOptions,
            AutoRuleConfig: autoRuleConfig
        };
    }

    /**
     * Create SayToken from SayRequest protocol.
     * @method CommandRequester.expression.Say#generateToken
     * @param {SayRequest} protocol - SayRequest protocol to generate a SayToken from.
     * @param {boolean} [andSend=false] - `true` if the generated SayToken should also be sent as a request.
     * @return {SayToken}
     * @intdocs
     */
    public generateToken(protocol: JIBO.v1.SayRequest, andSend=false): SayToken {
        const token = new SayToken(this.owner, protocol);
        if (andSend) {
            super.sendToken(token);
        }
        return token;
    }

    /**
     * Send SayToken request.
     * <p>NOTE: Implementation in base class {@link RequestAPI}</p>
     * @method CommandRequester.expression.Say#sendToken
     * @param {SayToken} token - SayToken to send.
     * @intdocs
     */
}
